import Header from "../Header";
import {
    Button,
    CircularProgress,
    Dialog, DialogActions, DialogContent, DialogContentText,
    DialogTitle,
    Fab,
    makeStyles,
    Snackbar,
    TextField,
    Typography
} from "@material-ui/core";
import spotifyLogo from "../../images/Spotify_Logo_RGB_White.png"
import {useParams, withRouter} from "react-router";
import React, {useEffect, useState} from "react";
import MuiAlert from '@material-ui/lab/Alert';
import Modal from '@material-ui/core/Modal';
import * as apiController from "../../controllers/apiController";
import {getState} from "../../controllers/stateController";


const useStyles = makeStyles((theme) => ({
        title: {
            alignSelf: "flex-start"
        },
        textInput: {
            background: "white",
            color: "black",
            fontSize: "x-large",
            fontWeight: "bold",

            },
        inputGroup: {
            display: "flex",
            margin: theme.spacing(2),
            flexDirection: 'column',

        },
        joinButton: {
            marginTop: theme.spacing(5),
            minWidth: 300,
        },
        joinButtonDisabled: {
            backgroundColor: "rgba(29, 185, 84, 1) !important",
            color: "white !important",
            cursor: "not-allowed !important",
            pointerEvents: "auto !important"
        },
        createButton: {
            marginTop: theme.spacing(2),
            minWidth: 300,
        },
        logo: {
            maxWidth: 300,
            imageRendering: "-webkit-optimize-contrast",
            marginTop: 50
        },
        loadingDiv: {
            display: "flex",
            height: "100vh",
            width: "100%",
            alignItems: "center",
            justifyContent: "center"
        }
}
));


function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}


function Home({history}) {
    const classes = useStyles();

    // qr code room
    let { room } = useParams();

    const [disabled, setDisabled] = useState(false)
    const [username, setUsername] = useState("");
    const [code, setCode] = useState(room === undefined ? "" : room.toUpperCase());

    // error message popup
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState("");

    // red outline error for text field
    const [codeError, setCodeError] = useState(false)
    const [nameError, setNameError] = useState(false)

    // dialog
    const [dialogOpen, setDialogOpen] = useState(false)


    useEffect(() => {
        if(global.room_subscription !== undefined) {
            global.room_subscription()
            global.room_subscription = undefined
        }
        if(global.user_subscription !== undefined) {
            global.user_subscription()
            global.user_subscription = undefined
        }
    }, [])

    // error message close
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    const handleDialogClose = () => {
        setDialogOpen(false);
    };


    // join button clicked
    const handleJoin = () => {
        // check if inputs are valid
        if(code === "") {
            setMessage("Code can not be blank.")
            setOpen(true)
            setCodeError(true)
            return;
        }
        else if(username === "") {
            setMessage("Name can not be blank.")
            setOpen(true)
            setNameError(true)
            return;
        }

        setDisabled(prev => !prev);
        apiController.joinRoom(code, username).catch((e) => {
            setDisabled(prev => !prev)
            setMessage(e.response.data)
            setOpen(true)
            setNameError(true)
        });
    }

    // create button clicked
    const handleCreate = () => {
        const state = getState()
        if(state.room_code !== undefined) {
            // show dialog
            setDialogOpen(true)
        }
        else {
            apiController.authorizeSpotify()
        }
    }

    const handleCodeInputChange = (e) => {
        setCode(e.target.value)
        setCodeError(false)
    }

    return(
        <div>
            <Header />
            <Modal open={disabled}>
                <div className={classes.loadingDiv} >
                    <CircularProgress size={140} />
                </div>
            </Modal>
            <Dialog
                open={dialogOpen}
                onClose={handleDialogClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Create new room session?"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        You have ongoing session. Do you want to rejoin your old session or create a new one. If
                        you create a new session, then your old on will be ended.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {apiController.authorizeSpotify()}} color="primary">
                        Create New Session
                    </Button>
                    <Button onClick={() => {history.push("/dashboard")}} color="primary" autoFocus>
                        Join Old Session
                    </Button>
                </DialogActions>
            </Dialog>
            <div style={{display:"flex", flexDirection: "column", alignItems: "center", justifyContent: "space-between", height: "90vh"}}>
                <div style={{display:"flex", flexDirection: "column", alignItems: "center"}}>
                    <div className={classes.inputGroup}>
                        <Typography variant="h6" className={classes.title}>
                            ROOM CODE
                        </Typography>
                        <TextField id="code"
                                   variant="outlined"
                                   defaultValue={room === undefined ? "" : room.toUpperCase()}
                                   error={codeError}
                                   InputLabelProps={{
                                       classes: {
                                           root: classes.textInput,
                                       },
                                   }}
                                   InputProps={{
                                       classes: {
                                           root: classes.textInput,
                                       },
                                   }}
                                   inputProps={{
                                       style: {
                                           textTransform: 'uppercase'
                                       },
                                       maxLength: 6
                                   }}
                                   placeholder="ENTER ROOM CODE"
                                   onChange={e => handleCodeInputChange(e)}
                        />
                    </div>
                    <div className={classes.inputGroup}>
                        <Typography variant="h6" className={classes.title}>
                            NAME
                        </Typography>
                        <TextField data-testid="field-name"
                                   variant="outlined"
                                   error={nameError}
                                   InputLabelProps={{
                                       classes: {
                                           root: classes.textInput,
                                       },
                                   }}
                                   InputProps={{
                                       classes: {
                                           root: classes.textInput,
                                       },
                                   }}
                                   inputProps={{
                                       maxLength: 20
                                   }}
                                   placeholder="ENTER YOUR NAME"
                                   onChange={e => {
                                       setUsername(e.target.value)
                                       setNameError(false)
                                   }}
                        />
                    </div>
                    <Fab
                        variant="extended"
                        size="large"
                        color="primary"
                        aria-label="join"
                        id="join-room"
                        classes={{
                            root: classes.joinButton,
                            disabled: classes.joinButtonDisabled
                        }}
                        disabled={disabled}
                        onClick={() => handleJoin()}
                    >
                        <Typography variant={"body1"}>
                            JOIN SESSION
                        </Typography>
                    </Fab>
                    <Fab
                        variant="extended"
                        size="large"
                        color="primary"
                        aria-label="create"
                        className={classes.createButton}
                        onClick={(e) => {e.target.setAttribute("disabled", true);
                        handleCreate()
                        }}
                    >
                        <Typography variant={"body1"}>
                            CREATE SESSION
                        </Typography>
                    </Fab>

                </div>
               <img src={spotifyLogo} alt={"Spotify_Logo_RGB_White"} className={classes.logo}/>
            </div>
            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="error">
                    {message}
                </Alert>
            </Snackbar>
        </div>
    )
}

export default withRouter(Home)
